import script from "./session-expired.vue?vue&type=script&setup=true&lang=js"
export * from "./session-expired.vue?vue&type=script&setup=true&lang=js"

import "./session-expired.vue?vue&type=style&index=0&id=9ca2ead2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ca2ead2"]])

export default __exports__